import type { ReactNode } from 'react';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { Card } from '@/components/ui/card.component';
import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface HelpActionCardProps {
  icon: IconDefinition;
  title: string;
  description: string;
  action: ReactNode;
  testId?: string;
}

export const HelpActionCard = ({
  icon,
  title,
  description,
  action,
  testId,
}: HelpActionCardProps) => {
  return (
    <Card className="flex flex-col gap-4 p-5 h-full" data-testid={testId}>
      <div className="flex items-center gap-2">
        <span className="bg-green-50 border border-gray-200/25 rounded-lg w-12 h-12 flex items-center justify-center shrink-0">
          <Icon icon={icon} className="w-6 h-6 text-green-500" />
        </span>
        <Typography variant={TypographyVariant.BODY_STRONG} as="h3">
          {title}
        </Typography>
      </div>
      <Typography variant={TypographyVariant.BODY_TEXT} as="p">
        {description}
      </Typography>
      <div className="mt-auto">{action}</div>
    </Card>
  );
};
